import {registerComponent} from '@helpers/vue'
import PoultryManagementPrototype from 'src/vue/areas/poultry-management-prototype/PoultryManagement'

registerComponent(PoultryManagementPrototype, 'poultry-management-prototype')
